// extracted by mini-css-extract-plugin
export default {"cls1":"KZ0013cEaUz9zEbXCwKq","cls2":"VbQcbhhq8_QsZgSUimob KZ0013cEaUz9zEbXCwKq"};